import { FirestoreError } from "firebase/firestore";

import { FirebaseData } from "../General/FirebaseData";
import { PropertyData } from "../Property/PropertyData";
import { LocalData } from "../General/LocalData";
import { LockHolderData } from "./LockHolderData";

export class FirebaseLockData extends FirebaseData {

  lockHolder: LockHolderData;
  name: string = "";
  unlocLockId: string = "";
  property?: PropertyData;

  constructor(id: string, collectionName: string, parent: FirebaseData | undefined) {
    super(id, collectionName, parent)
    this.lockHolder = parent as LockHolderData;
  }

  setup(data: any) {
    this.name = typeof data.name === "string" ? data.name : "";
    this.unlocLockId = typeof data.unlocLockId === "string" ? data.unlocLockId : "";
    this.property = typeof data.propertyId === "string" && data.propertyId ? LocalData.properties.addData(data.propertyId) : undefined;

    super.setup(data);
  }

  updateProperty(property: PropertyData, completion: (error?: FirestoreError) => void) {
    this.saveUpdateWithCompletionHandler({
      propertyId: property.id,
    }, error => {
      if (!error) this.property = property;
      completion(error)
    })
  }
}
